import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function updateDigitalAssetDefinition({ id, payload }) {
  try {
    const url = paths.updateDigitalAssetDefinition(id);
    const response = await axiosInstance.put(url, payload);

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useUpdateDigitalAsset = () => {
  return useMutation({
    mutationFn: updateDigitalAssetDefinition,
  });
};

export { useUpdateDigitalAsset };
